"use client";

import React from "react";

export function useFlipCard(autoResetMs?: number) {
  const [isFlipped, setIsFlipped] = React.useState(false);

  React.useEffect(() => {
    if (!isFlipped || autoResetMs == null) return;
    const timer = setTimeout(() => setIsFlipped(false), autoResetMs);
    return () => clearTimeout(timer);
  }, [isFlipped, autoResetMs]);

  const toggle = React.useCallback(() => setIsFlipped((v) => !v), []);

  return { isFlipped, setIsFlipped, toggle };
}
